// extracted by mini-css-extract-plugin
export default {"container":"franchise_container__N0HpF","items":"franchise_items__qbkDE","item":"franchise_item__p9VR1","mobileContainer":"franchise_mobileContainer__iViwi"};